import * as IMAGE from '../../lib/image/event/EventFallImages';
import * as PATH from '../../lib/routes/path';

export const ID_FALL = 'fall';
export const PERIOD_FALL = {
  startDate: '2025-09-01T00:00:00',
  endDate: '9999-12-31T23:59:59',
};

export const EVENT_HOME_BANNER_FALL = {
  id: ID_FALL,
  period: PERIOD_FALL,
  image: IMAGE.HOME_BANNER_FALL,
  path: PATH.SALES,
};
